import { useEffect } from 'react';
import ReactGA from 'react-ga4';

import { syncCustomerIo } from '../../api/ceremony';
import { OrdainedModel, saveOrdained } from '../../api/ordained';
import { Modal } from '../../components/v2/Modal/Modal';
import { sendCustomerIoEventHandler } from '../../helpers/customerIoHelper';
import { getAPIErrorMessage } from '../../helpers/helper';
import { useChecklist } from '../../provider/checklistProvider';
import { useDashboard } from '../../provider/dashboardProvider';
import { useSnackbar } from '../../provider/snackbarProvider';

import OrdainedApplicationForm from './OrdinationApplicationForm';

const OrdainedApplicationModal = () => {
  const {
    ordainedApplicationModalOpen,
    setOrdainedApplicationModalOpen,
    setOrdainedSuccessModalOpen,
    ceremony,
    fetchOrdained,
  } = useDashboard();

  const { openSnackBar } = useSnackbar();
  const { fetchChecklistItems } = useChecklist();

  useEffect(() => {
    if (ordainedApplicationModalOpen) {
      //Timeout is added to prevent the elevio widget from showing up on the next modal if they are chained
      setTimeout(() => {
        document.body.classList.add('remove-elevio');
      }, 300);
    } else {
      //window._elev.closeAllPopups();
      document.body.classList.remove('remove-elevio');
    }
    return () => {
      //window._elev.closeAllPopups();
      document.body.classList.remove('remove-elevio');
    };
  }, [ordainedApplicationModalOpen]);

  const onSubmit = async (values: OrdainedModel) => {
    try {
      if (!ceremony) {
        return;
      }
      const response = await saveOrdained(values, ceremony.id);
      if (response.success) {
        ReactGA.event({
          category: 'Ordination',
          action: 'Ordination Finished',
          label: 'Ordination Finished',
        });

        void fetchOrdained();

        setOrdainedApplicationModalOpen(false);
        setOrdainedSuccessModalOpen(true);

        void sendCustomerIoEventHandler('Gets Ordained', {
          name: `${values.firstName} ${values.lastName}`,
        });

        void syncCustomerIo({
          ceremonyId: ceremony.id,
        });

        void fetchChecklistItems(ceremony.id, false);
      } else {
        openSnackBar(response.message, 'error');
      }
    } catch (err) {
      //hideLoader();
      openSnackBar(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        getAPIErrorMessage(err as any),
        'error'
      );
    }

    setOrdainedApplicationModalOpen(false);
  };

  return (
    <Modal
      isOpen={ordainedApplicationModalOpen}
      onClose={() => setOrdainedApplicationModalOpen(false)}
    >
      <OrdainedApplicationForm onSubmit={onSubmit} />
    </Modal>
  );
};

export default OrdainedApplicationModal;
